<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800&display=swap');

.container-card-items {
    min-height: 20vh;
    width: 100%;
    background: #f3f4f7;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    padding-bottom: 30px;
    padding-top: 30px;
    border-radius: 15px;
}

.container-card-items form {
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, .1);
    padding: 20px;
    width: 600px;
    padding-top: 140px;
}

.container-card-items form .inputBox {
    margin-top: 20px;
    font-size: 14px;
}

.container-card-items form .inputValue {
    margin-top: 20px;
    font-size: 14px;
}

.container-card-items form .inputValue input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, .3);
    color: #0C5A9D;
    display: flex;
}

.container-card-items form .inputBox span {
    display: block;
    color: #0C5A9D;
    padding-bottom: 5px;
}

.container-card-items form input,
.container-card-items form select {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, .3);
    color: #0C5A9D;
}

.container-card-items form .flexbox {
    display: flex;
    gap: 15px;

}

.container-card-items form .flexbox .inputBox {
    flex: 1 1 150px;
}

.container-card-items form .submit-btn {
    width: 100%;
    background: linear-gradient(45deg, #074275, #0574d4);
    margin-top: 20px;
    padding: 10px;
    font-size: 20px;
    color: #fff;
    cursor: pointer;
    transition: .2s linear;
    border: linear-gradient(45deg, #074275, #0574d4) 2px solid;
}

.container-card-items form .submit-btn:hover {
    opacity: .8;
}

.container-card-items .card-container {
    margin-bottom: -120px;
    position: relative;
    height: 250px;
    width: 400px;
}

    .container-card-items .card-container .front {
        font-family: 'Open Sans', sans-serif;
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #0C5A9D, #0574d4);
        border-radius: 15px;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .3);
        padding: 20px;
        transform: perspective(1000px) rotateY(0deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

.container-card-items .card-container .front .image {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 10px;
}

.container-card-items .card-container .front .image img {
    height: 50px;
}

.container-card-items .card-container .front .card-number-box {
    padding: 30px;
    font-size: 22px;
    color: #fff;
}

.container-card-items .card-container .front .flexbox {
    display: flex;
}

.container-card-items .card-container .front .flexbox .box:nth-child(1) {
    margin-right: auto;
}

.container-card-items .card-container .front .flexbox .box {
    font-size: 15px;
    color: #fff;
}

.container-card-items .card-container .back {
    font-size: 'Source Code Pro';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(45deg, #052f55, #0574d4);
    border-radius: 15px;
    padding: 20px 0;
    text-align: right;
    backface-visibility: hidden;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
    transform: perspective(1000px) rotateY(180deg);
    transition: transform .4s ease-out;
    background: no-repeat center center fixed;
}

.container-card-items .card-container .back .stripe {
    background: #141414;
    width: 100%;
    margin: 10px 0;
    height: 50px;
}

.container-card-items .card-container .back .box {
    padding: 0 20px;
}

.container-card-items .card-container .back .box span {
    color: #fff;
    font-size: 15px;
}

.container-card-items .card-container .back .box .cvv-box {
    height: 50px;
    padding: 10px;
    margin-top: 5px;
    color: #333;
    background: #fff;
    border-radius: 5px;
    width: 100%;
}

.container-card-items .card-container .back img {
    margin-top: 30px;
    height: 30px;
}

@media (max-width: 750px) {

    .container-card-items form {
        padding: 18px;
        width: 550px;
        padding-top: 140px;
    }

    .container-card-items form .inputBox {
        margin-top: 18px;
        font-size: 12px;
    }

    .container-card-items form .inputValue {
        margin-top: 20px;
        font-size: 12px;
    }

    .container-card-items form .inputValue input {
        width: 100%;
        padding: 9px;
    }

    .container-card-items form .inputBox span {
        padding-bottom: 4px;
    }

    .container-card-items form input,
    .container-card-items form select {
        width: 100%;
        padding: 9px;
    }


    .cart-table-data>td {
        font-size: 14px;
    }

    .container-card-items form .submit-btn {
        font-size: 14px;
        padding: 8px;
    }

}

@media (max-width: 650px) {

    .container-card-items form {
        padding: 18px;
        width: 500px;
        padding-top: 140px;
    }

    .container-card-items form .inputBox {
        margin-top: 18px;
        font-size: 11px;
    }

    .container-card-items form .inputValue {
        margin-top: 20px;
        font-size: 11px;
    }

    .container-card-items form .inputValue input {
        width: 100%;
        padding: 8px;
    }

    .container-card-items form .inputBox span {
        padding-bottom: 4px;
    }

    .container-card-items form input,
    .container-card-items form select {
        width: 100%;
        padding: 8px;
    }


    .cart-table-data>td {
        font-size: 13px;
    }

    .container-card-items form .submit-btn {
        font-size: 13px;
        padding: 7px;
    }

    /* Cartão */

    .container-card-items .card-container {
        margin-bottom: -135px;
        position: relative;
        height: 200px;
        width: 350px;
    }

    .container-card-items .card-container .front {
        font-size: 'Source Code Pro';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #0C5A9D, #0574d4);
        border-radius: 15px;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .3);
        padding: 16px;
        transform: perspective(1000px) rotateY(0deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

    .container-card-items .card-container .front .image {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 5px;
    }

    .container-card-items .card-container .front .image img {
        height: 25px;
        width: 20px;
    }

    .container-card-items .card-container .front .card-number-box {
        padding: 20px;
        font-size: 14px;
        color: #fff;
    }

    .container-card-items .card-container .front .flexbox {
        display: flex;
    }

    .container-card-items .card-container .front .flexbox .box:nth-child(1) {
        margin-right: auto;
    }

    .container-card-items .card-container .front .flexbox .box {
        font-size: 14px;
        color: #fff;
    }

    .container-card-items .card-container .back {
        font-size: 'Source Code Pro';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(45deg, #052f55, #0574d4);
        border-radius: 15px;
        padding: 16px 0;
        text-align: right;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
        transform: perspective(1000px) rotateY(180deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

    .container-card-items .card-container .back .stripe {
        background: #141414;
        width: 100%;
        margin: 10px 0;
        height: 40px;
    }

    .container-card-items .card-container .back .box {
        padding: 0 18px;
    }

    .container-card-items .card-container .back .box span {
        color: #fff;
        font-size: 12px;
    }

    .container-card-items .card-container .back .box .cvv-box {
        height: 40px;
        padding: 10px;
        margin-top: 5px;
        color: #333;
        background: #fff;
        border-radius: 5px;
        width: 100%;
    }

    .container-card-items .card-container .back img {
        margin-top: 20px;
        height: 30px;
    }

}

@media (max-width: 550px) {

    .container-card-items form {
        padding: 18px;
        width: 400px;
        padding-top: 150px;
    }

    .container-card-items form .inputBox {
        margin-top: 14px;
        font-size: 11px;
    }

    .container-card-items form .inputValue {
        margin-top: 20px;
        font-size: 10px;
    }

    .container-card-items form .inputValue input {
        width: 100%;
        padding: 7px;
    }

    .container-card-items form .inputBox span {
        padding-bottom: 4px;
    }

    .container-card-items form input,
    .container-card-items form select {
        width: 100%;
        padding: 7px;
    }


    .cart-table-data>td {
        font-size: 12px;
    }

    .container-card-items form .submit-btn {
        font-size: 12px;
        padding: 6px;
    }

    /* Cartão */

    .container-card-items .card-container {
        margin-bottom: -135px;
        position: relative;
        height: 150px;
        width: 250px;
    }

    .container-card-items .card-container .front {
        font-size: 'Source Code Pro';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #0C5A9D, #0574d4);
        border-radius: 15px;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .3);
        padding: 16px;
        transform: perspective(1000px) rotateY(0deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
        background-size: 400px;
    }

    .container-card-items .card-container .front .image {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 5px;
    }

    .container-card-items .card-container .front .image img {
        margin-top: 10px;
        height: 28px !important;
        width: 42px !important;
    }

    .container-card-items .card-container .front .card-number-box {
        padding: 8px;
        font-size: 14px;
        color: #fff;
    }

    .container-card-items .card-container .front .flexbox {
        display: flex;
    }

    .container-card-items .card-container .front .flexbox .box:nth-child(1) {
        margin-right: auto;
    }

    .container-card-items .card-container .front .flexbox .box {
        font-size: 10px;
        color: #fff;
    }

    .container-card-items .card-container .back {
        font-size: 'Source Code Pro';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(45deg, #052f55, #0574d4);
        border-radius: 15px;
        padding: 16px 0;
        text-align: right;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
        transform: perspective(1000px) rotateY(180deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

    .container-card-items .card-container .back .stripe {
        background: #141414;
        width: 100%;
        margin: 2px 0;
        height: 30px;
    }

    .container-card-items .card-container .back .box {
        padding: 0 18px;
    }

    .container-card-items .card-container .back .box span {
        color: #fff;
        font-size: 10px;
    }

    .container-card-items .card-container .back .box .cvv-box {
        height: 35px;
        padding: 8px;
        margin-top: 0px;
        color: #333;
        background: #fff;
        border-radius: 5px;
        width: 100%;
    }

    .container-card-items .card-container .back img {
        margin-top: 10px;
        height: 22px !important;
        width: 45px !important;
    }

    .cart-table-data>td {
        font-size: 10px;
    }

    .col-xs-12 {
        overflow: scroll;
    }


}

@media (max-width: 400px) {

    .container-card-items form {
        padding: 18px;
        width: 300px;
        padding-top: 150px;
    }

    .container-card-items form .inputBox {
        margin-top: 14px;
        font-size: 13px;
        width: 250px;
    }

    .container-card-items form .inputValue {
        margin-top: 20px;
        font-size: 12px;
    }

    .container-card-items form .inputValue input {
        width: 100%;
        padding: 7px;
    }

    .container-card-items form .inputBox span {
        padding-bottom: 4px;
    }

    .container-card-items form input,
    .container-card-items form select {
        width: 100%;
        padding: 7px;
    }

    .container-card-items form .flexbox {
        display: unset;
    }

    .cart-table-data>td {
        font-size: 12px;
    }

    .container-card-items form .submit-btn {
        font-size: 10px;
        padding: 10px;
    }

    /* Cartão */

    .container-card-items .card-container {
        margin-bottom: -135px;
        position: relative;
        height: 150px;
        width: 250px;
    }

    .container-card-items .card-container .front {
        font-size: 'Source Code Pro';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(45deg, #0C5A9D, #0574d4);
        border-radius: 15px;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .3);
        padding: 16px;
        transform: perspective(1000px) rotateY(0deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
        background-size: 400px;
    }

    .container-card-items .card-container .front .image {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 5px;
    }

    .container-card-items .card-container .front .image img {
        margin-top: 10px;
        height: 28px !important;
        width: 40px !important;
    }

    .container-card-items .card-container .front .card-number-box {
        padding: 8px;
        font-size: 14px;
        color: #fff;
    }

    .container-card-items .card-container .front .flexbox {
        display: flex;
    }

    .container-card-items .card-container .front .flexbox .box:nth-child(1) {
        margin-right: auto;
    }

    .container-card-items .card-container .front .flexbox .box {
        font-size: 10px;
        color: #fff;
    }

    .container-card-items .card-container .back {
        font-size: 'Source Code Pro';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(45deg, #052f55, #0574d4);
        border-radius: 15px;
        padding: 16px 0;
        text-align: right;
        backface-visibility: hidden;
        box-shadow: 0 15px 25px rgba(0, 0, 0, .2);
        transform: perspective(1000px) rotateY(180deg);
        transition: transform .4s ease-out;
        background: no-repeat center center fixed;
    }

    .container-card-items .card-container .back .stripe {
        background: #141414;
        width: 100%;
        margin: 2px 0;
        height: 30px;
    }

    .container-card-items .card-container .back .box {
        padding: 0 18px;
    }

    .container-card-items .card-container .back .box span {
        color: #fff;
        font-size: 10px;
    }

    .container-card-items .card-container .back .box .cvv-box {
        height: 35px;
        padding: 8px;
        margin-top: 0px;
        color: #333;
        background: #fff;
        border-radius: 5px;
        width: 100%;
    }

    .container-card-items .card-container .back img {
        margin-top: 10px;
        height: 22px !important;
        width: 45px !important;
    }

    .cart-table-data>td {
        font-size: 10px;
    }

    .col-xs-12 {
        overflow: scroll;
    }

}
</style>

<template>
    <main id="main" class="main-site">
        <div class="container" style="margin-bottom: 30px; margin-top: 30px;">
            <div class="col-md-12" style="margin-bottom: 25px; margin-top: 15px;">
                <a href="https://www.aldo.com.br/loja">
                    <img src="/assets/images/calculadora-solar/logo-aldo-solar.jpg" width="180" alt="Aldo Solar">
                </a>
            </div>
            <div v-if="mostrarInfoPedido">
                <div class="row">
                    <h3 class="text-center">
                        <strong>
                            DETALHES DO PAGAMENTO
                        </strong>
                    </h3>
                </div>
                <div class="row">
                    <h4 class="text-center">
                        Bem vindo, {{ nomeDoCliente }}.
                    </h4>
                </div>
                <br />
                <hr class="row" width="max" style="border-width: 1px;" />
                <div class="row" style="color: #0C5A9D;">
                    <div class="col-md-12 text-center" style="margin-bottom: 25px;">
                        <h4>
                            PEDIDO
                        </h4>
                        <h4 style="color: black;">
                            {{ pedido.codigo }}-{{ pedido.codigodv }}
                        </h4>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-4">
                                <h5 style="color:black; font-weight: 600;">
                                    Revenda
                                </h5>
                            </div>
                            <div class="col-md-8">
                                <h6 style="color:black;">
                                    {{ pedido.nomeDaRevenda }}
                                </h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <h5 style="color:black; font-weight: 600;">
                                    Vendedor
                                </h5>
                            </div>
                            <div class="col-md-8">
                                <h6 style="color:black;">
                                    {{ pedido.nomeDoVendedor }}
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-4">
                                <h5 style="color:black; font-weight: 600;">
                                    Data do pedido
                                </h5>
                            </div>
                            <div class="col-md-8">
                                <h6 style="color:black;">
                                    {{ pedido.dataDoPedido }}
                                </h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <h5 style="color:black; font-weight: 600;">
                                    Cidade
                                </h5>
                            </div>
                            <div class="col-md-8">
                                <h6 style="color:black;">
                                    {{ pedido.cidadeUfDoPedido }}
                                </h6>
                            </div>
                        </div>

                    </div>
                    <br />
                    <hr class="row" width="max" style="border-width: 1px;" />
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <table style="width:100%">
                                    <tr class="cart-table-header">
                                        <th class="text-center">Código</th>
                                        <th class="text-center">Foto</th>
                                        <th>Descrição</th>
                                        <th class="text-center">Qtde</th>
                                        <th class="text-center">Valor Unitário</th>
                                        <!--<th class="text-center"><i class="fa fa-exclamation-circle fa-lg" /></th>-->
                                    </tr>
                                    <tr class="cart-table-data" v-for="(product, index) in pedido.produtosDoPedido"
                                        :key="index">
                                        <td class="text-center">{{ product.codigo }}-{{ product.codigodv }}</td>
                                        <td class="text-center"><img class="cart-table-img" v-bind:src="product.img" /></td>
                                        <td>{{ product.subGrupo + " " + product.descricao }}</td>
                                        <td class="text-center">{{ product.quantidade }}</td>
                                        <td class="text-center">{{ converterParaReal(product.valorUnitario) }}</td>
                                        <!--<td class="text-center"><i class="fa fa-exclamation-circle fa-lg cart-product-info" style="color:#0083ca"><ProductTaxesTooltip :productTaxes="produtosDoPedido.taxes" :origin="produtosDoPedido.origin" /></i></td>-->
                                    </tr>
                                </table>
                                <div class="row">
                                    <div class="col-md-12" style="color:black;">
                                        <span class="cart-table-foot pull-right">Total: {{ pedido.totalFormatado }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 20px;">
                        <div class="col-md-12 text-center">
                            <a
                                :href="boletoLink"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="btn btn-primary"
                                style="border-radius: 25px; padding: 12px 32px; font-size: 18px; background: linear-gradient(45deg, #074275, #0574d4); border: none; color: #fff; text-decoration: none; margin-top: 10px;"
                            >
                                Visualizar Boleto
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { convertNumberToReal } from '../../Utils/formatNumber';
import './OrderPayment.css';
import axios from 'axios';

export default {
    name: "OrderPaymentBoleto",
    components: {
        //ProductTaxesTooltip,
    },
    mounted() {
        this.getDadosPedido(this.$route.params.codigoLink);

        let pagseguroscript = document.createElement('script')
        pagseguroscript.setAttribute('src', 'https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js')
        document.head.appendChild(pagseguroscript)

        setTimeout(() => {
            $('.cvv-input').on("focus", () => {
                $('.front').css("transform", 'perspective(1000px) rotateY(-180deg)');
                $('.back').css("transform", 'perspective(1000px) rotateY(0deg)');
            })

            $('.cvv-input').on("blur", () => {
                $('.front').css("transform", 'perspective(1000px) rotateY(0deg)');
                $('.back').css("transform", 'perspective(1000px) rotateY(-180deg)');
            })
        }, 1000);

        this.abrirBoleto();
    },
    data() {
        return {
            codigoLink: '',
            nomeDoCliente: '',
            nossoNumero: '',
            pedido: {
                codigo: 0,
                codigodv: 0,
                nomeDaRevenda: '',
                cidadeUfDoPedido: '',
                dataDoPedido: '',
                nomeDoVendedor: '',
                formaDePagamento: '',
                subTotalFormatado: '',
                totalFormatado: '',
                produtosDoPedido: [],
            },
            resumoPagamento: {
                botaoFinalizarLiberado: false,
            },
            mostrarInfoPedido: false,
            mostrarInfoPagamento: false,
            mensagemStatusCarregamentoPedido: 'Carregando dados do pedido, por favor aguarde...'
        }
    },
    computed: {
        boletoLink() {
            return this.nossoNumero
                ? `https://www.aldo.com.br/Financeiro/duplicatavista/${this.nossoNumero}`
                : '#';
        }
    },
    methods: {
        converterParaReal: function (number) {
            return convertNumberToReal(number);
        },
        liberaFinalizacao: function () {
            this.resumoPagamento.botaoFinalizarLiberado =
                this.validacaoCartao.numeroCartaoValido &&
                this.validacaoCartao.nomeImpressoValido &&
                this.validacaoCartao.vencimentoValido &&
                this.validacaoCartao.cvvValido;
        },
        getDadosPedido: function (codigoLink) {
            axios
                .get(this.$apiUrl + "Pagamento.svc/GetPaymentInfoBoleto/" + codigoLink)
                .then((response) => {
                    if (response.data) {
                        var respostaApi = response.data;
                        this.nomeDoCliente = respostaApi.NomeCliente;
                        this.nossoNumero = respostaApi.NossoNumero;
                        this.pedido.codigo = respostaApi.PedidoPagamento.CodigoPedido;
                        this.pedido.codigodv = respostaApi.PedidoPagamento.CodigoDvPedido;
                        this.pedido.nomeDaRevenda = respostaApi.PedidoPagamento.NomeRevenda;
                        this.pedido.nomeDoVendedor = respostaApi.PedidoPagamento.NomeVendedor;
                        this.pedido.formaDePagamento = respostaApi.PedidoPagamento.DescricaoFormaDePagamento;
                        this.pedido.dataDoPedido = respostaApi.PedidoPagamento.DataFormatada;
                        this.pedido.cidadeUfDoPedido = respostaApi.PedidoPagamento.Cidade + ', ' + respostaApi.PedidoPagamento.Uf;
                        this.pedido.subTotalFormatado = respostaApi.PedidoPagamento.SubTotalFormatado;
                        this.pedido.totalFormatado = respostaApi.PedidoPagamento.TotalFormatado;
                        this.pedido.totalJuros = respostaApi.PedidoPagamento.Juros * respostaApi.PedidoPagamento.SubTotal / 100;
                        this.pedido.produtosDoPedido = respostaApi.PedidoPagamento.ProdutosPedidoPagamento.map((produto) => {
                            return {
                                codigo: produto.Codigo,
                                codigodv: produto.CodigoDv,
                                img: produto.UrlImagem,
                                descricao: produto.Descricao,
                                quantidade: produto.Quantidade,
                                valorUnitario: produto.ValorUnitario,
                                subGrupo: produto.SubGrupo,
                            }
                        });
                        this.mostrarInfoPedido = true
                    } else {
                        //PEDIDO EM ANALISE
                        this.mostrarInfoPedido = false;
                        this.mostrarInfoPagamento = true;
                    }
                })
                .catch(() => {
                    this.mostrarInfoPedido = false
                    this.mensagemStatusCarregamentoPedido = 'Pedido não encontrado ou não disponível para pagamento.'
                });
        },
    }
}

</script>
